import { ZERO_ROTATION } from '@sb/geometry';

import type { SchunkEGxState } from './types/SchunkEGxState';
import type { SchunkEGxVariant } from './types/SchunkEGxVariant';
import { schunkEGxVariantInfo } from './utils/schunkEGxVariantInfo';

export function getDefaultTooltipTransform(variant: SchunkEGxVariant) {
  const variantInfo = schunkEGxVariantInfo(variant);

  return {
    ...ZERO_ROTATION,
    x: 0,
    y: 0,
    z: variantInfo.height,
  };
}

export const DefaultTooltipTransform = {
  ...ZERO_ROTATION,
  x: 0,
  y: 0,
  z: 0.09,
} as const;

export const SCHUNK_EGK_INITIAL_STATE: SchunkEGxState = {
  kind: 'SchunkEGx',
  variant: null,
  isConnected: false,
  isBusy: false,

  readyForOperation: false,
  controlAuthorityFieldbus: false,
  readyForShutdown: false,
  commandSuccessfullyProcessed: false,
  commandReceivedToggle: false,
  releasedForManualMovement: false,
  softwareLimitReached: false,
  noWorkpieceDetected: false,
  workpieceGripped: false,
  positionReached: false,
  workpiecePregripStarted: false,
  gpeActivated: false,
  workpieceLost: false,
  wrongWorkpieceGripped: false,

  position: 0,
  jawPosition: 0,
  errorCode: 0,
  warningCode: 0,
  notFeasibleCode: 0,
};

export const SCHUNK_MODBUS_TARGET_ADDRESS = 0x0c;

// The plc_sync_input register is off by 1 according to
// 5.3.3, example 1 in the [Schunk manual](https://schunk.com/us/en/gripping-systems/parallel-gripper/egk/egk-40-mb-m-b/p/000000000001491762)
export const SCHUNK_EGK_MODBUS_PLC_SYNC_INPUT = 0x40 - 1;
export const SCHUNK_EGK_MODBUS_PLC_SYNC_OUTPUT = 0x48 - 1;
export const SCHUNK_EGK_MODBUS_ZERO_POS_OFS = 0x0610 - 1;
export const SCHUNK_EGK_MODBUS_GRP_POS_MARGIN = 0x0580 - 1;
export const SCHUNK_EGK_MODBUS_GRP_PREPOS_DELTA = 0x05a8 - 1;
export const SCHUNK_EGK_MODBUS_MIN_POS = 0x0600 - 1;
export const SCHUNK_EGK_MODBUS_MAX_POS = 0x0608 - 1;
export const SCHUNK_GRP_POS_MARGIN_MM = 10; // max position margin for force grip with position

// 1mm safety margin to prevent position commands from hitting gripper limits
export const SCHUNK_POSITION_MARGIN = 0.001;

// Safety margin to prevent speed commands from hitting gripper limits (NF_DESIRED_VELOCITY_OUT_OF_RANGE)
export const SCHUNK_SPEED_MARGIN = 0.002;
